<template>
    <v-dialog v-model="shows" max-width="480">
        <template #activator="{ attrs, on }">
            <slot name="default" v-bind="{ attrs, on }" />
        </template>
        <v-card class="v-card--dialog">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">선물하기 발송내역</h3>
                <v-btn fab color="transparent" @click="exit" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-divider />
            <div class="v-card--dialog__body page-text">
                <v-sheet max-width="240" class="mx-auto px-3 py-12">
                    <v-row class="row--small">
                        <v-col cols="5" class="font-weight-bold"> 연락처 </v-col>
                        <v-col cols="7" class="text-end"> {{ value?.gift?.phone?.phoneNumberFormat?.() || "-" }} </v-col>
                        <v-col cols="5" class="font-weight-bold"> 보내는 금액 </v-col>
                        <v-col cols="7" class="text-end"> {{ value?.gift?.amount?.format?.() || 0 }} 원 </v-col>
                        <v-col cols="5" class="font-weight-bold"> 발송회수 </v-col>
                        <v-col cols="7" class="text-end"> {{ value?.gift?.count?.format?.() || 0 }} 회 </v-col>
                        <v-col cols="5" class="font-weight-bold"> 상태 </v-col>
                        <v-col cols="7" class="text-end"> {{ value.type }} </v-col>
                    </v-row>
                </v-sheet>
            </div>
            <div class="v-card--dialog__foot" v-if="!disabled">
                <v-row no-gutters align="end">
                    <v-col>
                        <v-row class="row--small primary--text">
                            <v-col cols="auto"> * </v-col>
                            <v-col class="page-text page-text--small">
                                발송가능 횟수는 총 3회입니다.
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="auto">
                        <v-row class="row--small">
                            <v-col cols="auto">
                                <v-btn v-bind="{ loading, disabled: disabled_redo }" color="primary" @click="$emit('redo')">
                                    <span>재발송</span>
                                </v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn v-bind="{ loading, disabled }" color="error" @click="$emit('undo')">
                                    <span>취소</span>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { initUserExchangeBulk } from "@/assets/lib";

export default {
    props: {
        /** @type {import('vue/types/umd').PropType<import('@/assets/lib').UserExchangeBulk>} */
        value: { type: Object, default: initUserExchangeBulk },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        disabled_redo() {
            return this.value.exchanges_toGift.length < 1 || 3 <= this.value.gift.count;
        },
        disabled() {
            return this.value.exchanges_toGift.length < 1;
        },
    },
    methods: {
        exit() {
            this.shows = false;
        },
    },
};
</script>

<style lang="scss" scoped></style>
